import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private _title: string = '';
  private readonly _state$ = new BehaviorSubject<TemplateRef<any> | null>(null);
  readonly state$ = this._state$.asObservable();

  get title(): string {
    return this._title;
  }

  open(
    event: MouseEvent | KeyboardEvent,
    templateRef: TemplateRef<any>,
    title: string
  ) {
    event.stopPropagation();
    if (
      event instanceof KeyboardEvent &&
      event.key !== ' ' &&
      event.key !== 'Enter'
    )
      return;
    this._title = title;
    this._state$.next(templateRef);
  }

  close(event: MouseEvent | KeyboardEvent | null = null) {
    if (
      event instanceof KeyboardEvent &&
      event.key !== ' ' &&
      event.key !== 'Enter'
    )
      return;
    this._title = '';
    this._state$.next(null);
  }
}
